export default {
    postLoader: {},
    postLoaderSearch:{},
    newFeeds  :{},
    trendingTags:{},
    trendingTagsSearch :{},
    popularTags :{},
    popularTagsSearch :{},
    discussions:{}
}